module.exports = __webpack_public_path__ + "media/promo/lum2021/images/flowers-c6dbf55a121b49bcb17ae0386e2411a8.png";